module.exports = ReduxThunk;


//////////////////
// WEBPACK FOOTER
// external "ReduxThunk"
// module id = 87
// module chunks = 0